import { StyleSheet } from 'react-native';
import {
  KeyboardAvoidingView,
  type KeyboardAvoidingViewProps,
} from 'react-native-keyboard-controller';
import { withUnistyles } from 'react-native-unistyles';

const style = StyleSheet.create({
  keyboardAvoidingView: {
    flex: 1,
  },
});

const UnistylesModalKeyboardAvoidingView = withUnistyles(KeyboardAvoidingView);

export default function ModalKeyboardAvoidingView({
  children,
  style: extraStyle,
  ...props
}: KeyboardAvoidingViewProps) {
  return (
    <UnistylesModalKeyboardAvoidingView
      automaticOffset
      behavior="padding"
      {...props}
      style={[style.keyboardAvoidingView, extraStyle]}
    >
      {children}
    </UnistylesModalKeyboardAvoidingView>
  );
}
